import { type Context, Copy } from "@b9g/crank";
import logoUrl from "../../assets/logo.svg";
import { formatDate } from "./format.ts";
import { MapView } from "./map.ts";
import { Sidebar } from "./sidebar.tsx";
import { Store } from "./store.ts";

function Header({ store }: { store: Store }) {
  return (
    <header class="header">
      <a class="header-home" href="/">
        <img src={logoUrl} alt="" width="22" height="22" />
        <span>OpenWetlandsMap</span>
      </a>
      <span class="spacer" />
      {store.updatedAt ? (
        <span class="header-meta" title={store.updatedAt.toISOString()}>
          Data updated {formatDate(store.updatedAt)}
        </span>
      ) : null}
      <a class="header-link" href={store.explorerUrl()} target="_blank" rel="noreferrer">
        Download data
      </a>
    </header>
  );
}

function* MapPane(this: Context<{ store: Store }, HTMLElement>, { store }: { store: Store }) {
  this.after((node) => {
    store.setMap(
      new MapView(node, store.selected, {
        onSelect: (ref) => store.select(ref),
        onChange: () => store.refresh(),
      }),
    );
  });
  this.cleanup(() => store.map?.remove());

  yield <div class="map" />;
  for ({} of this) yield <Copy />;
}

export function* App(this: Context) {
  const store = new Store(() => this.refresh());

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") store.deselect();
  };
  addEventListener("keydown", onKeyDown);
  this.cleanup(() => removeEventListener("keydown", onKeyDown));

  for ({} of this) {
    yield (
      <>
        <Header store={store} />
        <div class="body">
          <div class="map-container">
            <MapPane store={store} />
            {store.interactive ? null : (
              <div class="zoom-hint" role="status">
                Zoom in to select individual wetlands
              </div>
            )}
          </div>
          <Sidebar store={store} />
        </div>
      </>
    );
  }
}
